export class ClientVersionInfo {
  /**
   * @param {string} gameVersion
   * @param {string} forcedVersion
   */
   constructor(gameVersion, forcedVersion) {
    this.gameVersion   = gameVersion;
    this.forcedVersion = forcedVersion;
  }
}